import React, { useState, useEffect } from "react";
// utils
import XGridDemo from "../../components/utils/grid/Xgrid";
import TransitionModal from "../../components/utils/modals/Modals";
import Buttons from '../../components/utils/buttonsContainer/Buttons';
// consts
import { rubrosDeMerchant as titles } from "../../consts/titulos-de-tablas";
import { modalsInfoRubrosDeMerchant as infoModal } from "../../consts/Modals-info";
//Assets
import CircularIndeterminate from '../../components/utils/spinner/Spinner';
//Services 
import { retrieveData } from '../../services/Local-services';
import { rubrosDeMerchantGet } from '../../services/hooli-services/RubrosDeMerchant/RubrosDeMerchantGet';
// recoil
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { userCredentials, rowSelected, formData } from '../../recoilState/GlobalState';

export default function RubrosDeMerchant() {
    const [rubros, setRubros] = useState([]);
    const [rows, setRows] = useState([]);
    const [action, setAction] = useState({});
    const [cargando, setCargando] = useState(true);

    const setRow = useSetRecoilState(rowSelected);
    const credentials = useRecoilValue(userCredentials);
    const setFormInfo = useSetRecoilState(formData);

    const updateList = async () => {
        setCargando(true);
        await retrieveData(credentials, setRows, rubrosDeMerchantGet, setRubros);
        setCargando(false);
    };

    useEffect(() => {
        if (Object.keys(credentials).length > 0) updateList()
    }, [credentials]);

    useEffect(() => {
        rubros.map((item) => {
            const {
                rubroMerchantId,
                rubroMerchantNombre,
                rubroMerchantCod,
                rubroMerchantEsAgencia,
                rubroMerchantADomicilio,
                rubroMerchantVersion,
                imagePathRUBROM
            } = item

            const rubro = {
                id: rubroMerchantId,
                agencia: rubroMerchantEsAgencia,
                domicilio: rubroMerchantADomicilio,
                version: rubroMerchantVersion,
                imagePathRUBROM,
                [titles[0]]: rubroMerchantNombre,
                [titles[1]]: rubroMerchantCod,
                [titles[2]]: rubroMerchantEsAgencia === 'Y' ? 'Si' : 'No',
                [titles[3]]: rubroMerchantADomicilio === 'Y' ? 'Si' : 'No'
            };

            setRows(rows => [...rows, rubro])
            return item
        });
    }, [rubros]);

    useEffect(() => setRow({ status: false }), [])

    const handleClick = ({ action, procede }) => {
        setFormInfo(infoModal[action]);
        setAction({ action, procede });
    };

    return (
        <main className="container">
            <TransitionModal
                titles={titles}
                procede={action.procede}
                updateList={updateList}
            />
            <Buttons texto="rubro" handleClick={handleClick} updateList={updateList} />
            <div className="row-grid" >
                {cargando ? <CircularIndeterminate /> : <XGridDemo rows={rows} titles={titles} />}
            </div>
        </main>
    )
};